import { useState } from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const FAQ_ITEMS = [
  {
    question: 'Is Galdorn free to play?',
    answer: 'Yes, Galdorn is free to play with no pay-to-win mechanics \u2014 every player competes on equal footing. The game is supported by unobtrusive ads. For \u20AC1 per age, you can go ad-free and unlock a permanent archive of your province history \u2014 a record of every reign you\u2019ve played.',
  },
  {
    question: 'How long does an age last?',
    answer: 'Each age lasts 12 weeks. At the end of an age, the world resets and a new round begins \u2014 giving everyone a fresh start. You can keep your kingdom together or land somewhere new.',
  },
  {
    question: 'Can I play solo?',
    answer: 'Absolutely. Solo play is fully viable, and intelligence warfare gives solo players a powerful edge. That said, cooperating with kingdom mates unlocks coordinated strategies that are hard to match alone.',
  },
  {
    question: 'How much time does it take per day?',
    answer: 'Galdorn is designed for strategic sessions, not constant attention. You can check in a few times a day to queue actions, review intelligence, and coordinate with your kingdom. During wars, you might be more active \u2014 but that\u2019s part of the thrill.',
  },
  {
    question: 'Is it mobile-friendly?',
    answer: 'Galdorn is browser-based and works on any device. The interface is optimized for desktop but fully usable on tablets and phones for on-the-go management.',
  },
];

export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref, isVisible } = useScrollReveal();

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="px-6 md:px-12 py-24 max-w-[1200px] mx-auto" ref={ref}>
      <div
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.6s ease, transform 0.6s ease',
        }}
      >
        <div
          className="mb-3 uppercase tracking-[0.15em]"
          style={{ fontFamily: "'Cinzel', serif", fontSize: 11, fontWeight: 600, color: '#a08030' }}
        >
          Frequently Asked Questions
        </div>
        <h2
          className="mb-8"
          style={{ fontFamily: "'Cinzel', serif", fontSize: 36, fontWeight: 700, color: '#f0e8dc', lineHeight: 1.2 }}
        >
          Common Questions
        </h2>

        <div className="max-w-[720px]">
          {FAQ_ITEMS.map((item, index) => (
            <div key={index} style={{ borderBottom: '1px solid #24201b', padding: '24px 0' }}>
              <button
                id={`faq-trigger-${index}`}
                aria-expanded={openIndex === index}
                aria-controls={`faq-panel-${index}`}
                onClick={() => toggle(index)}
                className="w-full flex justify-between items-center gap-4 text-left"
                style={{
                  fontFamily: "'Cinzel', serif",
                  fontSize: 17,
                  fontWeight: 600,
                  color: '#ddd0c0',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                }}
              >
                {item.question}
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="shrink-0"
                  style={{
                    color: '#635850',
                    transition: 'transform 0.3s',
                    transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0)',
                  }}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              {openIndex === index && (
                <div
                  id={`faq-panel-${index}`}
                  role="region"
                  aria-labelledby={`faq-trigger-${index}`}
                  className="pt-3"
                  style={{ color: '#e0d5c8', fontSize: 16, lineHeight: 1.7 }}
                >
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
